var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-container is-flex justify-center align-center"},[_c('div',{staticClass:"auth-form"},[_c('el-card',[_c('client-form')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }